package nl.volleyplanner.web.controller.thuisprogramma

import kotlinx.html.TagConsumer
import kotlinx.html.h1
import kotlinx.html.js.div
import nl.volleyplanner.web.base.component
import org.w3c.dom.HTMLElement


class ThuisProgrammaViewerComponent(
    thuisprogrammaDataManager: ThuisprogrammaDataManager
) : AbstractThuisprogrammaComponent(
    thuisprogrammaDataManager.problemSlug,
    thuisprogrammaDataManager
) {
    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        val thuisprogrammaComponent = ThuisprogrammaComponent(
            problemSlug,
            null,   // Never show other versions in viewer
            thuisprogrammaDataManager
        )
        return consumer.div {
            h1 { +"Programma thuiswedstrijden" }
            component(thuisprogrammaComponent)
        }
    }

    override suspend fun getState() = null
}